// 業者新規作成画面
import React, { useState, useEffect, useCallback } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Theme,
  Divider,
  Button,
  Snackbar,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  Tooltip
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import NumberInput from '../components/NumberInput';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SearchIcon from '@material-ui/icons/Search';
import './List.css';
import { useHistory, Redirect } from 'react-router-dom';
import 'date-fns';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  furiganaRegex,
  invalidPhoneNumberRegex
} from '../GlobalState';
import { getPrefecture, getEndOfDay } from '../apicalls/createCustomer';
import {
  getIndustryTypes,
  saveVendor,
  getIndustryNamesFromIds,
  getVendorTypeLarge,
  getVendorRank
} from '../apicalls/getVendorDetails';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { DialogProps } from '@material-ui/core/Dialog';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TTopicPathState } from '../components/topicPath/type/Type';

interface State {
  arr: any;
}

interface CheckedState {
  check: any;
}

export const CreateVendor: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [isFurigana] = useRecoilState(furiganaRegex);
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [vendorTypeLargeData, setVendorTypeLargeData] = useState([]);
  const [vendorRankData, setVendorRankData] = useState([]);

  const [prefecture, setPrefecture] = useState([]);
  const [endOfDay, setEndOfDay] = useState([]);
  const [partnerCategories, setPartnerCategories] = useState<any>([]);

  const [selectedTraderType, setSelectedTraderType] = useState<number>(0);

  const [partnerCategoryIds, setPartnerCategoryIds] = useState<any>([]);
  const [partnerCategoryDetailIds, setPartnerCategoryDetailIds] = useState<any>(
    []
  );

  const [companyName, setCompanyName] = useState('');
  const [furigana, setFurigana] = useState('');
  const [selectedPrefecture, setSelectedPrefecture] = useState<number>(0);
  const [representativeName, setRepresentativeName] = useState('');
  const [capital, setCapital] = useState<number>();
  const [numberOfEmployees, setNumberOfEmployees] = useState<number>();
  const [selectedEstablishMonth] = useState<number>(0);
  const [selectedPersonInCharge, setSelectedPersonInCharge] = useState('');
  const [personInChargeTel, setPersonInChargeTel] = useState('');
  const [personInChargeEmail, setPersonInChargeEmail] = useState('');
  const [tel, setTel] = useState('');
  const [fax, setFax] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [address3, setAddress3] = useState('');
  const [bankName, setBankName] = useState('');
  const [branchName, setBranchName] = useState('');
  const [selectedAccountType, setSelectedAccountType] = useState<number>(0);
  const [accountNumber, setAccountNumber] = useState('');
  const [accountName, setAccountName] = useState('');
  const [selectedEndOfDay, setSelectedEndOfDay] = useState<number>(0);
  const [selectedPaymentSiteMonth, setSelectedPaymentSiteMonth] = useState('');
  const [selectedPaymentSiteDate, setSelectedPaymentSiteDate] = useState('');
  const [selectedRounding] = useState<number>(0);
  const [remarks, setRemarks] = useState('');
  const [selectedRankId, setSelectedRankId] = useState<number>();

  const [partnerCategory, setPartnerCategory] = useState('');
  const [partnerCategoryDetails, setPartnerCategoryDetails] = useState('');

  const [checkedSmall, setCheckedSmall] = useState<CheckedState>({ check: [] });
  const [pressedSmall] = useState([]);

  const [countSmall] = useState(0);
  const [checkBoxSelectedSmall, setCheckBoxSelectedSmall] = useState(false);

  function handleChangeSmall(index: number) {
    for (let i = 0; i < countSmall; i++) {
      if (checkedSmall.check[i] === false) {
        // setSelectionSmall(false)
      }
    }

    let checkedBox: any = [...checkedSmall.check];
    checkedBox[index] = !checkedSmall.check[index];
    setCheckedSmall({ check: checkedBox });
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const matches2 = useMediaQuery('(min-width:900px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        width: matches2 ? 600 : '80%'
      },

      subContainer: {
        marginLeft: 15,
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        minheight: 60,
        maxHeight: 200,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      }
    })
  );

  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const classes = useStyles();
  const history: any = useHistory();

  const getAllPrefectures = useCallback(() => {
    getPrefecture().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setPrefecture(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllEndOfDay = useCallback(() => {
    getEndOfDay().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setEndOfDay(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllIndustryTypes = useCallback(() => {
    getIndustryTypes().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setPartnerCategories(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllVendorTypeLarge = useCallback(() => {
    getVendorTypeLarge().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setVendorTypeLargeData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllVendorRank = useCallback(() => {
    getVendorRank().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setVendorRankData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  useEffect(() => {
    getAllPrefectures();
    getAllEndOfDay();
    getAllIndustryTypes();
    getAllVendorTypeLarge();
    getAllVendorRank();
  }, [
    getAllPrefectures,
    getAllEndOfDay,
    getAllIndustryTypes,
    getAllVendorTypeLarge,
    getAllVendorRank
  ]);

  const saveVendorDetails = () => {
    let val =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (selectedTraderType === 0) {
      setErrorMessage('業者種別を選択してください。');
      setOpen(true);
    } else if (partnerCategoryIds.length === 0) {
      setErrorMessage('業種（大項目）を選択してください。');
      setOpen(true);
    } else if (partnerCategoryDetailIds.length === 0) {
      setErrorMessage('業種（小項目）を選択してください。');
      setOpen(true);
    } else if (companyName.trim() === '') {
      setErrorMessage('会社名を入力してください。');
      setOpen(true);
    } else if (companyName.length > 20) {
      setErrorMessage('会社名は20文字以内で入力してください。');
      setOpen(true);
    } else if (furigana.trim() === '') {
      setErrorMessage('ふりがなを入力してください。');
      setOpen(true);
    } else if (!isFurigana.test(furigana.trim())) {
      setErrorMessage('無効なふりがなです。');
      setOpen(true);
    }
    // else if (selectedPersonInCharge === 0) {
    //   setErrorMessage("担当者を選択してください。");
    //   setOpen(true);
    // }
    else if (
      personInChargeTel.trim() !== '' &&
      personInChargeTel.trim().length > 60
    ) {
      setErrorMessage('無効な担当者TELです。');
      setOpen(true);
    } else if (
      personInChargeEmail.trim() !== '' &&
      !val.test(personInChargeEmail.trim())
    ) {
      setErrorMessage('無効な担当者メールアドレスです。');
      setOpen(true);
    } else if (tel.trim() !== '' && tel.trim().length > 60) {
      setErrorMessage('無効なTELです。');
      setOpen(true);
    } else {
      saveVendor(
        selectedTraderType,
        partnerCategoryIds,
        partnerCategoryDetailIds,
        companyName.trim(),
        furigana.trim(),
        representativeName.trim(),
        capital,
        numberOfEmployees,
        selectedEstablishMonth,
        selectedPrefecture,
        address1.trim(),
        address2.trim(),
        address3.trim(),
        tel.trim(),
        fax,
        bankName.trim(),
        branchName.trim(),
        selectedAccountType,
        accountNumber,
        accountName.trim(),
        selectedEndOfDay,
        selectedPaymentSiteMonth,
        selectedPaymentSiteDate,
        selectedRounding,
        selectedPersonInCharge.trim(),
        personInChargeTel.trim(),
        personInChargeEmail.trim(),
        remarks.trim(),
        selectedRankId
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSuccessMessage(data.message);
              setOpenSuccess(true);
              setTimeout(() => {
                history.goBack();
              }, 2000);
            }
          }
        }
      });
    }
  };

  const getTheDetailsOfSelectedIndustryTypes = () => {
    getIndustryNamesFromIds(partnerCategoryIds, partnerCategoryDetailIds).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setPartnerCategory(data.data.partner_categories);
              setPartnerCategoryDetails(data.data.partner_category_details);
            }
          }
        }
      }
    );
  };

  // パンくずリスト用に検索パラメーターを設定
  const patternState: TTopicPathState = {};
  patternState['/vendors'] = history.location.state;

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent
        patternName='vendors_create'
        patternState={patternState}
      />
      <div
        style={{
          overflow: 'hidden',
          backgroundColor: '#F5F5F5',
          minHeight: window.innerHeight
        }}
      >
        <div style={{ margin: 15 }}>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <Snackbar
            open={openSuccess}
            autoHideDuration={4000}
            onClose={handleCloseSuccess}
          >
            <Alert onClose={handleCloseSuccess} severity='success'>
              {successMessage}
            </Alert>
          </Snackbar>

          <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby='max-width-dialog-title'
          >
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                <div>
                  <div
                    className='border1'
                    style={{ display: 'flex', flexDirection: 'row' }}
                  >
                    <div style={{ flex: 2.3 }}>
                      <div style={{ padding: 10, backgroundColor: mainColor }}>
                        <div style={{ color: '#FFFFFF' }}>大項目</div>
                      </div>
                    </div>

                    <div style={{ flex: 3 }}>
                      <div
                        style={{
                          paddingLeft: 30,
                          padding: 10,
                          backgroundColor: mainColor
                        }}
                      >
                        <div style={{ color: '#FFFFFF' }}> 小項目</div>
                      </div>
                    </div>
                  </div>

                  {partnerCategories.map((i: any, k: number) => (
                    <div
                      className='border1'
                      style={{ display: 'flex', flexDirection: 'row' }}
                    >
                      {i.category_detail.length > 0 && (
                        <>
                          <div
                            style={{
                              flex: 2.3,
                              backgroundColor:
                                k % 2 === 0 ? '#F5F5F5' : '#FFFFFF'
                            }}
                          >
                            <div style={{ padding: 3 }}>
                              <Checkbox
                                checked={
                                  partnerCategoryIds.includes(i.id)
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  // const found = newSmallArr.some((r: any) => i.b_type_ids.indexOf(r) >= 0)
                                  var ind = partnerCategoryIds.indexOf(i.id);
                                  // 選択された小項目ID
                                  let detail_ids = partnerCategoryDetailIds;
                                  if (ind === -1) {
                                    setPartnerCategoryIds([
                                      ...partnerCategoryIds,
                                      i.id
                                    ]);
                                    // 配下の小項目を全選択する
                                    let checkedBox: any = [
                                      ...checkedSmall.check
                                    ];
                                    i.category_detail.forEach((deteil: any) => {
                                      detail_ids.push(deteil.id);
                                      checkedBox[deteil.id] = true;
                                    });
                                    setCheckedSmall({ check: checkedBox });
                                    setPartnerCategoryDetailIds(detail_ids);
                                  } else {
                                    setPartnerCategoryIds(
                                      partnerCategoryIds.filter(
                                        (char: any, aa: any) => aa !== ind
                                      )
                                    );
                                    // 配下の小項目も選択されている場合は除外する
                                    let checkedBox: any = [
                                      ...checkedSmall.check
                                    ];
                                    i.category_detail.forEach((deteil: any) => {
                                      if (detail_ids.includes(deteil.id)) {
                                        const index = detail_ids.indexOf(
                                          deteil.id
                                        );
                                        if (index > -1) {
                                          detail_ids.splice(index, 1);
                                          checkedBox[deteil.id] =
                                            !checkedSmall.check[deteil.id];
                                        }
                                      }
                                    });
                                    setCheckedSmall({ check: checkedBox });
                                    setPartnerCategoryDetailIds(detail_ids);
                                  }
                                }}
                                style={{
                                  color: partnerCategoryIds.includes(i.id)
                                    ? buttonColor
                                    : '#758283'
                                }}
                              />
                              {i.name}
                            </div>
                          </div>

                          <div
                            style={{
                              flex: 3,
                              backgroundColor:
                                k % 2 === 0 ? '#F5F5F5' : '#FFFFFF'
                            }}
                          >
                            {i.category_detail.map((j: any, index: number) => (
                              <div style={{ padding: 3 }}>
                                <Checkbox
                                  checked={
                                    checkedSmall.check[j.id] ? true : false
                                  }
                                  onClick={() => {
                                    handleChangeSmall(j.id);
                                    let newArr = partnerCategoryDetailIds;
                                    if (
                                      !checkedSmall.check[j.id] &&
                                      !pressedSmall[j.id]
                                    ) {
                                      newArr.push(j.id);
                                      setPartnerCategoryDetailIds(newArr);
                                    } else {
                                      var ind =
                                        partnerCategoryDetailIds.indexOf(j.id);
                                      if (ind !== -1)
                                        partnerCategoryDetailIds.splice(ind, 1);
                                    }
                                    setCheckBoxSelectedSmall(
                                      !checkBoxSelectedSmall
                                    );

                                    let newSmallArr = partnerCategoryDetailIds;
                                    const found = newSmallArr.some(
                                      (r: any) => i.detail_ids.indexOf(r) >= 0
                                    );
                                    if (
                                      found === true &&
                                      !partnerCategoryIds.includes(i.id)
                                    ) {
                                      setPartnerCategoryIds([
                                        ...partnerCategoryIds,
                                        i.id
                                      ]);
                                    } else {
                                      setPartnerCategoryIds(
                                        partnerCategoryIds.filter(
                                          (char: any, aa: any) => aa !== ind
                                        )
                                      );
                                    }
                                  }}
                                  style={{
                                    color: checkedSmall.check[j.id]
                                      ? buttonColor
                                      : '#758283'
                                  }}
                                />
                                {j.name}
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                  <div></div>
                </div>
              </DialogContentText>
            </DialogContent>
            <div
              style={{
                marginBottom: 20,
                marginTop: 10,
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Button
                style={{ backgroundColor: buttonColor }}
                variant='contained'
                color='primary'
                onClick={() => {
                  handleCloseModal();
                  getTheDetailsOfSelectedIndustryTypes();
                }}
              >
                保存
              </Button>
            </div>
          </Dialog>

          <div>
            <div
              className='table-top-container-customer'
              style={{ backgroundColor: '#FFFFFF' }}
            >
              <div
                style={{
                  fontWeight: 'bold',
                  padding: 15,
                  paddingBottom: 0,
                  fontSize: 24
                }}
              >
                業者データ基本情報
              </div>
            </div>

            <Grid
              container
              style={{
                backgroundColor: '#FFFFFF',
                marginBottom: 15,
                paddingBottom: 15
              }}
            >
              <Grid item xs={matches2 ? 4 : 12}>
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      業者種別<span>*</span>
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      <select
                        value={selectedTraderType}
                        className={classes.selectBoxStyle}
                        form='carform'
                        onChange={text => {
                          setSelectedTraderType(parseInt(text.target.value));
                        }}
                      >
                        <option value={0}>選択してください</option>
                        {vendorTypeLargeData.map((i: any) => (
                          <option value={i.id}>{i.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      <span style={{ marginRight: 5 }}>
                        業種（大項目）<span>*</span>
                      </span>
                      <CustomTooltip
                        title={tooltipContents.vendorsListCreateEdit}
                        placement='top'
                      >
                        <Button
                          style={{
                            padding: 5,
                            paddingLeft: 8,
                            paddingRight: 8,
                            color: '#758283',
                            backgroundColor: '#F5F5F5'
                          }}
                          variant='contained'
                          color='secondary'
                          startIcon={<SearchIcon />}
                          onClick={handleOpenModal}
                        >
                          選択
                        </Button>
                      </CustomTooltip>
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div
                      style={{
                        padding: 10,
                        display: 'flex',
                        fontSize: 14,
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}
                    >
                      {partnerCategory}
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      業種（小項目）<span>*</span>
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div
                      style={{
                        padding: 10,
                        fontSize: 14,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}
                    >
                      {partnerCategoryDetails}
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      会社名<span>*</span>
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={companyName}
                        maxLength={20}
                        placeholder='20文字以内'
                        onChange={text => {
                          setCompanyName(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      ふりがな<span>*</span>
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={furigana}
                        maxLength={60}
                        onChange={text => {
                          setFurigana(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>担当者</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={selectedPersonInCharge}
                        maxLength={30}
                        onChange={text => {
                          setSelectedPersonInCharge(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>担当者TEL</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={personInChargeTel}
                        maxLength={60}
                        onChange={text => {
                          setPersonInChargeTel(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>
                      担当者メールアドレス
                    </div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={personInChargeEmail}
                        maxLength={50}
                        onChange={text => {
                          setPersonInChargeEmail(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              style={{
                backgroundColor: '#FFFFFF',
                marginBottom: 15,
                paddingBottom: 15
              }}
            >
              <Grid item xs={matches2 ? 4 : 12}>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF', height: 50 }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    詳細情報
                  </div>
                </div>

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>都道府県</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      <select
                        value={selectedPrefecture}
                        onChange={text => {
                          setSelectedPrefecture(parseInt(text.target.value));
                        }}
                        className={classes.selectBoxStyle}
                        name='cars'
                        id='cars'
                        form='carform'
                      >
                        <option value={0}>選択してください</option>
                        {prefecture.map((i: any) => (
                          <option value={i.id}>{i.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>代表者氏名</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={representativeName}
                        maxLength={20}
                        onChange={text => {
                          setRepresentativeName(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>資本金</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <NumberInput
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          setCapital(parseInt(e.target.value));
                        }}
                        value={capital}
                        maxLength={15}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
              </Grid>

              <Grid item xs={matches2 ? 4 : 12}>
                {matches2 && (
                  <div
                    className='table-top-container-customer'
                    style={{ backgroundColor: '#FFFFFF', height: 50 }}
                  >
                    <div
                      style={{
                        fontWeight: 'bold',
                        padding: 15,
                        paddingBottom: 0,
                        fontSize: 24
                      }}
                    ></div>
                  </div>
                )}
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>社員数</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={numberOfEmployees}
                        min={0}
                        max={99999999}
                        onChange={text => {
                          if (text.target.value.length <= 8) {
                            setNumberOfEmployees(parseInt(text.target.value));
                          }
                        }}
                        type='number'
                        className={classes.input}
                        onWheel={(e: any) => e.target.blur()}
                      />
                    </div>
                  </div>
                </div>

                {/*
                <Divider style={{ backgroundColor: "#CCCCCC", marginLeft: 15 }} />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>設立</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      <select value={selectedEstablishMonth} onChange={(text) => {
                        setSeletedEstablishMonth(parseInt(text.target.value))
                      }} className={classes.selectBoxStyle} form="carform">
                        <option value={0}>選択してください</option>
                        <option value={1}>1</option>
                        <option value={2}>2</option>
                        <option value={3}>3</option>
                        <option value={4}>4</option>
                        <option value={5}>5</option>
                        <option value={6}>6</option>
                        <option value={7}>7</option>
                        <option value={8}>8</option>
                        <option value={9}>9</option>
                        <option value={10}>10</option>
                        <option value={11}>11</option>
                        <option value={12}>12</option>
                      </select>
                    </div>
                  </div>
                </div>
*/}
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>TEL</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        onChange={text => {
                          setTel(text.target.value);
                        }}
                        value={tel}
                        maxLength={60}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>FAX</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        onChange={text => {
                          setFax(text.target.value);
                        }}
                        value={fax}
                        maxLength={20}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
              </Grid>

              <Grid item xs={matches2 ? 4 : 12}>
                {matches2 && (
                  <div
                    className='table-top-container-customer'
                    style={{ backgroundColor: '#FFFFFF', height: 50 }}
                  >
                    <div
                      style={{
                        fontWeight: 'bold',
                        padding: 15,
                        paddingBottom: 0,
                        fontSize: 24
                      }}
                    ></div>
                  </div>
                )}
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>本所所在地</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={address1}
                        maxLength={100}
                        onChange={text => {
                          setAddress1(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>事業所所在地</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={address2}
                        maxLength={100}
                        onChange={text => {
                          setAddress2(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>他の場所</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={address3}
                        maxLength={100}
                        onChange={text => {
                          setAddress3(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              style={{
                backgroundColor: '#FFFFFF',
                marginBottom: 15,
                paddingBottom: 15
              }}
            >
              <Grid item xs={matches2 ? 4 : 12}>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    支払先情報
                  </div>
                </div>
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>銀行名</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={bankName}
                        maxLength={30}
                        onChange={text => {
                          setBankName(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />

                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>支店名</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        value={branchName}
                        maxLength={30}
                        onChange={text => {
                          setBranchName(text.target.value);
                        }}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>口座種別</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      <select
                        value={selectedAccountType}
                        onChange={text => {
                          setSelectedAccountType(parseInt(text.target.value));
                        }}
                        className={classes.selectBoxStyle}
                        name='cars'
                        id='cars'
                        form='carform'
                      >
                        <option value={0}>選択してください</option>
                        <option value={1}>普通</option>
                        <option value={2}>当座</option>
                      </select>
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>口座番号</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        type='number'
                        value={accountNumber}
                        min={0}
                        max={9999999999}
                        onChange={text => {
                          if (text.target.value.length <= 10) {
                            setAccountNumber(text.target.value);
                          }
                        }}
                        className={classes.input}
                        onWheel={(e: any) => e.target.blur()}
                      />
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>名義人</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainer}>
                      <input
                        onChange={text => {
                          setAccountName(text.target.value);
                        }}
                        value={accountName}
                        maxLength={80}
                        className={classes.input}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              style={{
                backgroundColor: '#FFFFFF',
                marginBottom: 15,
                paddingBottom: 15
              }}
            >
              <Grid item xs={matches2 ? 4 : 12}>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    取引情報
                  </div>
                </div>
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>締日</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div className={classes.inputContainerSelectBox}>
                      <select
                        value={selectedEndOfDay}
                        onChange={text => {
                          setSelectedEndOfDay(parseInt(text.target.value));
                        }}
                        className={classes.selectBoxStyle}
                        name='cars'
                        id='cars'
                        form='carform'
                      >
                        <option value={0}>選択してください</option>
                        {endOfDay.map((i: any) => (
                          <option value={i.id}>{i.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>支払いサイト</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div
                      className={classes.inputContainerSelectBox}
                      style={{ display: 'flex', flexDirection: 'row' }}
                    >
                      <select
                        value={selectedPaymentSiteMonth}
                        onChange={text => {
                          setSelectedPaymentSiteMonth(text.target.value);
                        }}
                        className={classes.selectBoxStyle}
                        name='cars'
                        id='cars'
                        form='carform'
                      >
                        <option value={''}>月を選択</option>
                        <option value={'当月'}>{'当月'}</option>
                        <option value={'翌月'}>{'翌月'}</option>
                        <option value={'翌々月'}>{'翌々月'}</option>
                        <option value={'翌々々月'}>{'翌々々月'}</option>
                      </select>

                      <select
                        style={{ marginLeft: 5 }}
                        value={selectedPaymentSiteDate}
                        onChange={text => {
                          setSelectedPaymentSiteDate(text.target.value);
                        }}
                        className={classes.selectBoxStyle}
                        name='cars'
                        id='cars'
                        form='carform'
                      >
                        <option value={''}>日付を選択</option>
                        <option value={'5'}>5</option>
                        <option value={'10'}>10</option>
                        <option value={'15'}>15</option>
                        <option value={'20'}>20</option>
                        <option value={'25'}>25</option>
                        <option value={'末'}>末</option>
                      </select>
                    </div>
                  </div>
                </div>
                <Divider
                  style={{
                    backgroundColor: '#CCCCCC',
                    marginLeft: 15,
                    width: '32%'
                  }}
                />
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer}>
                    <div className={classes.textContainer}>ランク</div>
                  </div>
                  <div className={classes.inputMainContainer}>
                    <div
                      className={classes.inputContainerSelectBox}
                      style={{ display: 'flex', flexDirection: 'row' }}
                    >
                      <select
                        value={selectedRankId}
                        onChange={text => {
                          setSelectedRankId(parseInt(text.target.value));
                        }}
                        className={classes.selectBoxStyle}
                        name='cars'
                        id='cars'
                        form='carform'
                      >
                        <option value={0}>選択してください</option>
                        {vendorRankData.map((i: any) => (
                          <option value={i.id}>{i.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <Divider
                  style={{
                    backgroundColor: '#CCCCCC',
                    marginLeft: 15,
                    width: '32%'
                  }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              style={{
                backgroundColor: '#FFFFFF',
                marginBottom: 15,
                paddingBottom: 15
              }}
            >
              <Grid item xs={matches2 ? 5 : 12}>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    備考
                  </div>
                </div>
                <div className={classes.subContainer}>
                  <div className={classes.textMainContainer1}>
                    <div className={classes.textContainer1}>備考</div>
                  </div>
                  <div className={classes.inputMainContainer1}>
                    <div className={classes.inputContainer}>
                      <textarea
                        value={remarks}
                        maxLength={225}
                        onChange={text => {
                          setRemarks(text.target.value);
                        }}
                        className={classes.input1}
                      />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                />
              </Grid>
            </Grid>
          </div>
        </div>

        <div style={{ height: 80 }} />
        <div
          className='save-btn-container'
          style={{
            backgroundColor: '#FFFFFF',
            position: 'fixed',
            bottom: 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'space-around'
          }}
        >
          <div />
          <div>
            <Button
              onClick={() => {
                saveVendorDetails();
              }}
              style={{
                paddingLeft: 50,
                paddingRight: 50,
                margin: 20,
                backgroundColor: buttonColor
              }}
              variant='contained'
              color='primary'
            >
              保存
            </Button>
          </div>
          <div />
        </div>
      </div>
    </>
  );
};
